import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { colors } from '../../../utils/theme';
import Stack, { ContentStack, contentStackSpacing } from '../../v2BaseComponents/Stack';
import Text from '../../v2BaseComponents/Text';
import MaxWidthRestrictedContent from '../../v2BaseComponents/MaxWidthRestrictedContent';
import Divider from '../../v2BaseComponents/Divider';
import Button from '../../v2BaseComponents/Button';
import { mainContentPadding } from '../../v2BaseComponents/MainContentContainer';

export type SubscriptionPlanDetailsOwnProps = {
    header: string;
    subHeader?: string;
    price?: string;
    subPrice?: string;
    features: string[];
    actionButtonText?: string;
    onActionButtonPress?: () => void;
    actionButtonTestID?: string;
    style?: StyleProp<ViewStyle>;
};

export type SubscriptionPlanDetailsProps = SubscriptionPlanDetailsOwnProps;

const SubscriptionPlanDetails: React.FC<SubscriptionPlanDetailsProps> = (props) => {
    return (
        <View
            style={[
                {
                    width: 370,
                    borderRadius: 30,
                    borderColor: colors.Primary,
                    borderWidth: 4,
                    overflow: 'hidden',
                    backgroundColor: colors.Primary,
                },
                props.style,
            ]}
        >
            <Stack
                fullWidth
                vertical
                style={{ padding: 4, backgroundColor: colors.Primary }}
                align="center"
                space={2}
                padding={mainContentPadding}
            >
                <Text variant="h3" color="White-Text" alignText="center" style={{ textTransform: 'uppercase' }}>
                    {props.header}
                </Text>
                {props.subHeader ? (
                    <Text variant="bold-h5" color="White-Text" alignText="center">
                        {props.subHeader}
                    </Text>
                ) : null}
            </Stack>
            <View style={{ width: '100%', flex: 1, padding: mainContentPadding, backgroundColor: colors.White }}>
                <ContentStack>
                    <Stack vertical align="center" justify={'center'} fullWidth>
                        {props.price ? <Text variant="h1">{props.price}</Text> : null}
                        {props.subPrice ? (
                            <Text variant="body-1" color="Primary-Reg">
                                {props.subPrice}
                            </Text>
                        ) : null}
                    </Stack>
                    <MaxWidthRestrictedContent maxWidth={300}>
                        <Stack vertical fullWidth space={contentStackSpacing} align="center">
                            {props.features.map((_, index) => (
                                <React.Fragment key={index + _}>
                                    {index !== 0 ? <Divider horizontal key={index} /> : null}
                                    <Stack horizontal fullWidth justify="center">
                                        <Text alignText="center" variant="bold-body-1" key={index}>
                                            {_}
                                        </Text>
                                    </Stack>
                                </React.Fragment>
                            ))}
                        </Stack>
                    </MaxWidthRestrictedContent>
                    {props.actionButtonText && props.onActionButtonPress ? (
                        <Stack vertical fullWidth align="center" style={{ marginTop: 10 }}>
                            <Button
                                variant="primary"
                                onPress={props.onActionButtonPress}
                                title={props.actionButtonText}
                                testID={props.actionButtonTestID}
                            />
                        </Stack>
                    ) : null}
                </ContentStack>
            </View>
        </View>
    );
};

export default React.memo(SubscriptionPlanDetails);
